import { alpha, Box, BoxProps } from '@mui/material';
import { clsx } from 'clsx';

type ContentReplacerProps = React.PropsWithChildren<{
    isActive: boolean;
    replacementContent: React.ReactNode;
    replacementContainerProps?: BoxProps;
    replacementContentWrapperProps?: BoxProps;
    className?: string;
    extraToolbar?: React.ReactNode;
}>;

const defaultClassName = 'relative flex-1 min-h-0';

const ContentReplacer = ({
    children,
    isActive,
    replacementContent,
    replacementContainerProps,
    replacementContentWrapperProps,
    className,
    extraToolbar,
}: ContentReplacerProps) => (
    <>
        {!isActive && extraToolbar}
        <div className={clsx(defaultClassName, className)}>
            {children}
            {isActive && (
                <Box
                    position="absolute"
                    zIndex={(theme) => theme.zIndex.appBar - 1}
                    bgcolor="#fff"
                    borderLeft={1}
                    borderColor={alpha('#000', 0.16)}
                    className="inset-0"
                    overflow="auto"
                    {...replacementContainerProps}
                >
                    <Box
                        maxWidth={1050}
                        width="100%"
                        mx="auto"
                        py={{ xs: '24px', md: '62px' }}
                        px="20px"
                        gap="32px"
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        minHeight={0}
                        {...replacementContentWrapperProps}
                    >
                        {replacementContent}
                    </Box>
                </Box>
            )}
        </div>
    </>
);

export { ContentReplacer };
